export const getInitials = (name: string) => {
  const userSplit = name.trim().split(' ')

  if (userSplit.length == 1) {
    return userSplit[0][0]?.toUpperCase() || ''
  }

  return `${userSplit[0][0]?.toUpperCase() || ''}${userSplit[1][0]?.toUpperCase() || ''}`
}
